import { ChevronDownIcon, ChevronRightIcon, CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import { Box, Container, Flex, Link, Text, useColorModeValue, useDisclosure, Image, Spacer, Stack, Menu, MenuButton, Button, Avatar, MenuList, MenuItem, MenuDivider, IconButton, Drawer, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, Popover, PopoverTrigger as OrigPopoverTrigger, PopoverContent, Center, Icon, Collapse, ButtonGroup } from "@chakra-ui/react";
import { FC, ReactElement, useEffect, useState } from "react"
import AppConst from "libs/appconst";
import { setStorage } from "utils/storage-utils";
import { useLocation } from "react-router-dom";
import PixelUtil from "utils/pixel-utils";
import ReactGA from "react-ga";
import AppConsts from "libs/appconst";
import AuthUtil from "utils/auth-utils";
import OidcAuthService from "../../services/auth/oidcAuthService";

interface LayoutProps {
    children: ReactElement
};

interface NavItem {
    label: string;
    subLabel?: string;
    children?: Array<NavItem>;
    href?: string;
    onClick?: any;
};

export const PopoverTrigger: React.FC<{ children: React.ReactNode }> = OrigPopoverTrigger;

const NAV_ITEMS: Array<NavItem> = [
    {
        label: 'Home',
        href: '/',
        onClick: () => {
            window.location.href = "/";
        }
    },
    {
        label: 'Programs',
        href: '/programs',
        onClick: () => {
            window.location.href = "/programs";
        }
    },
    {
        label: 'Konsultan Edukasi',
        href: AppConst.UrlSupportTeam,
        onClick: () => {
            PixelUtil.TrackSupportLinkClicked();
            window.open(AppConst.UrlSupportTeam);
        }
    }
];

const Logo = (props: any) => {
    return (
        <img {...props} width={'128px'} viewBox="0 0 120 28" src={process.env.PUBLIC_URL + '/images/logo.png'} alt='' />
    );
};

const WithSubnavigation = () => {
    const { isOpen, onToggle } = useDisclosure();
    //const { isOpen, onOpen, onClose } = useDisclosure();


    const handleClickLogin = () => {
        PixelUtil.TrackLoginButtonClicked();
        console.log(AppConst.Logos_APPURL);
        window.location.href = AppConst.Logos_APPURL;
    };

    const handleClickRegister = () => {
        PixelUtil.TrackHomepageRegisterButtonClicked();
        window.open("/register");
    };

    return (
        <Box>
            <Flex
                bg={useColorModeValue('white', 'gray.800')}
                color={useColorModeValue('gray.600', 'white')}
                minH={'60px'}
                py={{ base: 2 }}
                px={{ base: 4 }}
                align={'center'}>

                <Flex flex={{ base: 1 }} justify={{ base: 'left', md: 'start' }} alignItems={"center"}>
                    <Link onClick={() => { window.location.href = "/" }}>
                        <Image src={process.env.PUBLIC_URL + "/images/logo.png"} h={'40px'} />
                    </Link>
                    <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
                        <DesktopNav />
                    </Flex>
                </Flex>
                <Spacer />

                <Stack
                    display={{ base: 'none', md: 'flex', sm: 'none' }}
                    flex={{ base: 1, md: 0 }}
                    justify={'flex-end'}
                    direction={'row'}
                    spacing={6}>
                    <ButtonGroup>
                        <Button variant={'ghost'} onClick={handleClickLogin}>Login</Button>
                        <Button variant={'outline'} colorScheme={"teal"} onClick={handleClickRegister}>Daftar Sekarang</Button>
                    </ButtonGroup>
                </Stack>

                <Box>
                    <Flex
                        flex={{ base: 1, md: 'auto' }}
                        display={{ base: 'flex', md: 'none' }}
                        placeItems={"end"}
                    >
                        <IconButton
                            onClick={onToggle}
                            icon={
                                isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
                            }
                            variant={'ghost'}
                            aria-label={'Toggle Navigation'}
                        />
                    </Flex>
                </Box>

            </Flex>

            <Collapse in={isOpen} animateOpacity>
                <MobileNav />
            </Collapse>
        </Box>
    );
}

const DesktopNav = () => {
    const location = useLocation();
    const linkColor = useColorModeValue('gray.600', 'gray.200');
    const linkHoverColor = useColorModeValue('teal.500', 'white');
    const popoverContentBgColor = useColorModeValue('white', 'gray.800');

    return (
        <Stack direction={'row'} spacing={4}>
            {NAV_ITEMS.map((navItem) => (
                <Box key={navItem.label}>
                    <Popover trigger={'hover'} placement={'bottom-start'}>
                        <PopoverTrigger>
                            <Link
                                p={2}
                                onClick={navItem.onClick}
                                fontSize={'sm'}
                                color={location.pathname == navItem.href ? linkHoverColor : linkColor}
                                fontWeight={location.pathname == navItem.href ? 'bold' : '500'}
                                _hover={{
                                    textDecoration: 'none',
                                    color: linkHoverColor,
                                }}>
                                {navItem.label}
                            </Link>
                        </PopoverTrigger>

                        {navItem.children && (
                            <PopoverContent
                                border={0}
                                boxShadow={'xl'}
                                bg={popoverContentBgColor}
                                p={4}
                                rounded={'xl'}
                                minW={'sm'}>
                                <Stack>
                                    {navItem.children.map((child: any) => (
                                        <DesktopSubNav key={child.label} {...child} />
                                    ))}
                                </Stack>
                            </PopoverContent>
                        )}
                    </Popover>
                </Box>
            ))}
        </Stack>
    );
};

const DesktopSubNav = ({ label, href, subLabel }: NavItem) => {
    return (
        <Link
            href={href}
            role={'group'}
            display={'block'}
            p={2}
            rounded={'md'}
            _hover={{ bg: useColorModeValue('pink.50', 'gray.900') }}>
            <Stack direction={'row'} align={'center'}>
                <Box>
                    <Text
                        transition={'all .3s ease'}
                        _groupHover={{ color: 'pink.400' }}
                        fontWeight={500}>
                        {label}
                    </Text>
                    <Text fontSize={'sm'}>{subLabel}</Text>
                </Box>
                <Flex
                    transition={'all .3s ease'}
                    transform={'translateX(-10px)'}
                    opacity={0}
                    _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
                    justify={'flex-end'}
                    align={'center'}
                    flex={1}>
                    <Icon color={'pink.400'} w={5} h={5} as={ChevronRightIcon} />
                </Flex>
            </Stack>
        </Link>
    );
};

const MobileNav = (user: any) => {
    return (
        <Stack
            bg={useColorModeValue('white', 'gray.800')}
            p={4}
            display={{ md: 'none' }}>

            {NAV_ITEMS.map((navItem) => (
                <MobileNavItem key={navItem.label} {...navItem} />
            ))}
            <MobileNavItem label={'Login'} href={AppConst.Logos_APPURL} onClick={() => {
                PixelUtil.TrackLoginButtonClicked();
                window.location.href = AppConst.Logos_APPURL;
            }} />
            <MobileNavItem label={'Daftar Sekarang'} href={'/register'} onClick={() => {
                PixelUtil.TrackHomepageRegisterButtonClicked();
                window.open("/register");
            }} />
        </Stack>
    );
};

const MobileNavItem = ({ label, children, href, onClick }: NavItem) => {
    const location = useLocation();
    const { isOpen, onToggle } = useDisclosure();
    const linkColor = useColorModeValue('gray.600', 'gray.200');
    const linkHoverColor = useColorModeValue('teal.500', 'white');

    return (
        <Stack spacing={4} onClick={children && onToggle}>
            <Flex
                py={2}
                as={Link}
                onClick={onClick}
                justify={'space-between'}
                align={'center'}
                borderBottom={'1px'}
                borderColor={'gray.100'}
                _hover={{
                    textDecoration: 'none',
                }}
            >
                <Text
                    color={location.pathname == href ? linkHoverColor : linkColor}
                    fontWeight={location.pathname == href ? 'bold' : '500'}
                    variant={"MenuItem"}>
                    {label}
                </Text>
                {children && (
                    <Icon
                        as={ChevronDownIcon}
                        transition={'all .25s ease-in-out'}
                        transform={isOpen ? 'rotate(180deg)' : ''}
                        w={6}
                        h={6}
                    />
                )}
            </Flex>

            <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
                <Stack
                    mt={2}
                    pl={4}
                    borderLeft={1}
                    borderStyle={'solid'}
                    borderColor={useColorModeValue('gray.200', 'gray.700')}
                    align={'start'}>
                    {children &&
                        children.map((child: any) => (
                            <Link key={child.label} py={2} href={child.href}>
                                {child.label}
                            </Link>
                        ))}
                </Stack>
            </Collapse>
        </Stack>
    );
};

const Layout: FC<LayoutProps> = ({ children }) => {
    const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear());

    useEffect(() => {
        if (window.location.search) {
            let searchParam = new URLSearchParams(window.location.search);
            var affiliateId = searchParam.get('aid');
            var utmSource = searchParam.get('utm_source');
            var utmMedium = searchParam.get('utm_medium');
            var utmCampaign = searchParam.get('utm_campaign');

            if (affiliateId) {
                setStorage("logos.aid", affiliateId, (24 * 60 * 60));
            }
            if (utmSource) {
                setStorage("logos.utm_source", utmSource, (24 * 60 * 60));
            }
            if (utmMedium) {
                setStorage("logos.utm_medium", utmMedium, (24 * 60 * 60));
            }
            if (utmCampaign) {
                setStorage("logos.utm_campaign", utmCampaign, (24 * 60 * 60));
            }

            //var baseUrl = window.location.href.replaceAll(window.location.search, '');
            //window.history.replaceState({}, '', baseUrl);
        }

        ////if (AuthUtil.IsOidcAuthenticated()) {

        //var oidcAuthService = new OidcAuthService();
        //oidcAuthService.getUser().then((res: any) => {
        //    console.log("ABC " + res);
        //});
        ////window.location.href = AppConst.Logos_APPURL;
        ////var currentUser = AuthUtil.GetCurrentUser();
        ////alert(JSON.stringify(currentUser));
        ////}
    }, []);

    return (
        <Box as='header'>
            <Container maxWidth={"8xl"} pl={0} pr={0}>
                <WithSubnavigation />
            </Container>
            <Box as="main" minHeight={'80vh'} mb={10}>
                {children}
            </Box>
            <Box
                bg={useColorModeValue('gray.50', 'gray.900')}
                color={useColorModeValue('gray.700', 'gray.200')}>
                <Box py={10}>
                    <Flex
                        align={'center'}
                        _before={{
                            content: '""',
                            borderBottom: '1px solid',
                            borderColor: useColorModeValue('gray.200', 'gray.700'),
                            flexGrow: 1,
                            mr: 8,
                        }}
                        _after={{
                            content: '""',
                            borderBottom: '1px solid',
                            borderColor: useColorModeValue('gray.200', 'gray.700'),
                            flexGrow: 1,
                            ml: 8,
                        }}>
                        <Logo />
                    </Flex>
                    <Text pt={6} fontSize={'sm'} textAlign={'center'}>
                        © {currentYear} {AppConsts.APP_NAME}. All rights reserved
                    </Text>
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;